"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBlockingContentRef = void 0;
const rect_1 = require("@reach/rect");
const useBlockedRect_1 = require("./useBlockedRect");
function useBlockingContentRef(ref) {
    const rect = rect_1.useRect(ref);
    useBlockedRect_1.useBlockedRect(rect);
}
exports.useBlockingContentRef = useBlockingContentRef;
//# sourceMappingURL=useBlockingContentRef.js.map